import {darken, lighten} from 'polished';

const baseColor = '#023d59';
// const baseColor = '#0d1b2a';
// background-color: #0d1d2f;
// background - color: #023d59;



const theme = {
    colors: {
        background1: '#0d1b2a',
        background2: baseColor,
        background3: lighten(0.05, baseColor),
        background4: darken(0.5, baseColor),
        background50: lighten(0.8, '#0d1b2a'),
        background5: '#5fa8d3',
        // backgroundPlay: '#e63946',
        // backgroundPlay: lighten(0.05, '#3D7D9F'),
        backgroundPlay: lighten(0.0, '#64dde3'),
        // backgroundPlay: lighten(0.05, '#3C6FA0'),
        borderPlay: '#36409f',
        buttons1: lighten(0.5, '#415a77'),
        textColor1: '#FFFFFF',
        textColor2: '#000000',
    },
};


export default theme;

// const theme = {
//     colors: {
//         background1: darken(0.05, baseColor),
//         background2: baseColor,
//         background3: lighten(0.06, baseColor),
//         background4: darken(0.2, baseColor),
//         background5: lighten(0.4, baseColor),
//         backgroundPlay: '#2AAA8A',
//         // backgroundPlay: '#a4ca09',
//         buttons1: lighten(0.4, baseColor),
//         textColor1: '#FFFFFF',
//         textColor2: '#000000',
//     },
// };

// const theme = {
//     colors: {
//         background1: '#1d3557',
//         background2: darken(0.09, '#457b9d'),
//         background3: darken(0.09, '#1d3557'),
//         background4: darken(0.2, '#1d3557'),
//         background5: lighten(0.3, '#1d3557'),
//         backgroundPlay: '#e63946',
//         // backgroundPlay: '#a4ca09',
//         buttons1: lighten(0.3, '#457b9d'),
//         textColor1: '#FFFFFF',
//         textColor2: '#000000',
//     },
// };

// const theme = {
//     colors: {
//         background1: darken(0.05, baseColor),
//         background2: baseColor,
//         background3: lighten(0.01, baseColor),
//         background4: darken(0.2, baseColor),
//         background5: lighten(0.4, baseColor),
//         backgroundPlay: '#e63946',
//         // backgroundPlay: '#a4ca09',
//         buttons1: lighten(0.4, baseColor),
//         textColor1: '#FFFFFF',
//         textColor2: '#000000',
//     },
// };
